import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import { useUser } from "@/stores";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../views/LoginView.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/LoginView.vue"),
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../views/LoginView.vue"),
  },
  {
    path: "/forgot",
    name: "forgot",
    component: () => import("../views/LoginView.vue"),
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("../views/LoginView.vue"),
  },
  {
    path: "/explorer/dashboard",
    name: "explorer",
    component: () => import("../views/ExplorerView.vue"),
    // meta: { requiresAuth: true },
    // beforeEnter: guard,
  },
  {
    path: "/explorer/reviews",
    name: "reviews",
    component: () => import("../views/ExplorerView.vue"),
  },
  {
    path: "/explorer/reviewers",
    name: "reviewers",
    component: () => import("../views/ExplorerView.vue"),
  },
  {
    path: "/explorer/elogin",
    name: "elogin",
    component: () => import("../views/ExplorerView.vue"),
  },
  {
    path: "/explorer/changelog",
    name: "changelog",
    component: () => import("../views/ExplorerView.vue"),
  },
  {
    path: "/explorer/faq",
    name: "faq",
    component: () => import("../views/ExplorerView.vue"),
  },
  {
    path: "/explorer/contact",
    name: "contact",
    component: () => import("../views/ExplorerView.vue"),
  },
  {
    path: "/explorer/settings",
    name: "settings",
    component: () => import("../views/ExplorerView.vue"),
  },
  {
    path: "/about",
    name: "aboutall",
    component: () => import("../views/AboutView.vue"),
  },
  {
    path: "/websites",
    name: "websites",
    component: () => import("../views/WebsitesView.vue"),
  },
  // {
  //   path: "/explorer",
  //   name: "explorer",
  //   component: () => import("../views/ExplorerView.vue"),
  // },
  {
    path: "/personalsample",
    name: "personalsample",
    component: () => import("../views/PersonalSampleView.vue"),
  },
  {
    path: "/checkoutexample",
    name: "checkoutexample",
    component: () => import("../views/CheckoutExampleView.vue"),
  },
  {
    path: "/contact",
    name: "contactall",
    component: () => import("../views/ContactView.vue"),
  },
  {
    path: "/techconsult",
    name: "techconsult",
    component: () => import("../views/TechConsultView.vue"),
  },
  {
    path: "/mentorship",
    name: "mentorship",
    component: () => import("../views/MentorshipView.vue"),
  },
  {
    path: "/art",
    name: "art",
    component: () => import("../views/ArtView.vue"),
  },
  {
    path: "/r/:reviewId",
    name: "review-home",
    component: () => import("../views/ReviewView.vue"),
  },
  {
    path: "/r",
    name: "review-remote",
    component: () => import("../views/ReviewView.vue"),
  },
  {
    path: "/invoice/:reviewId",
    name: "invoice",
    component: () => import("../views/InvoiceView.vue"),
  },
  {
    path: "/qb/success",
    name: "success",
    component: () => import("../views/SuccessView.vue"),
  },
  {
    path: "/stripe/success",
    name: "stripeSuccess",
    component: () => import("../views/StripeSuccessView.vue"),
  },
  {
    path: "/square/success",
    name: "squareSuccess",
    component: () => import("../views/SquareConnectSuccessView.vue"),
  },
  {
    path: "/terms",
    name: "terms",
    component: () => import("../views/TermsView.vue"),
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

const signOutUser = (to, from, router) => {
  const userStore = useUser();
  userStore.signOutUser();
};

router.beforeEach((to, from, next) => {
  // console.log("router beforeEach")
  // console.log("before each", to, from, next);
  const userStore = useUser();

  if (to.name === "logout") {
    signOutUser(to, from, router);
    userStore.activeTab = "login";
    next("/login");
  } else if (to.path.includes("/explorer")) {
    userStore.activeTab = to.path;
    next();

    // // console.log("router explorer");
    // if (userStore.user) {
    //   // console.log("router user exists");
    //   userStore.activeTab = to.name || "";
    //   next();
    // } else {
    //   // console.log("router user does not exist");
    //   userStore.activeTab = "login";
    //   next("/login");
    // }
  } else {
    // No authentication required for the route, allow access
    next();
  }

  // TODO: get meta field working
  // console.log("to.meta.requiresAuth: ", to.meta.requiresAuth);
  // const requiresAuth = to.matched.some((route) => route.meta.requiresAuth);
  // if (requiresAuth) {
  // if (dumpStore.user) {
  //   // console.log("user is logged in");
  // } else {
  //   // console.log("user is not logged in");
  //   next("/login");
  // }
  // TODO: get this working, maybe it should go in a store?
  // Check the user's authentication state
  // const auth = getAuth();
  // console.log("auth: ", auth);
  // onAuthStateChanged(auth, (user) => {
  //   console.log("onAuthStateChanged");
  //   console.log("user: ", user);
  //   if (user) {
  //     // User is signed in, allow access
  //     console.log("user is signed in");
  //     dumpStore.user = user;
  //     next();
  //   } else {
  //     // User is not signed in, redirect to the login page
  //     console.log("user is not signed in");
  //     dumpStore.user = null;
  //     router.push("/login");
  //   }
  // });
  // }
});

export default router;
